import classNames from "classnames";
import { FormattedText, Icon } from "client/Components";
import { NumberFormatter, useCallbackWithoutArguments } from "client/Hooks";
import {
	isNil,
	isNotNil,
	setTrackingId
} from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./VotersOptionLayout.module.less";

export type VotersOptionLayoutProps = {
	trackingId: string;
};

export const VotersOptionLayout = (props: PropsWithChildren<VotersOptionLayoutProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
		>
			{children}
		</div>
	);
};
VotersOptionLayout.displayName = "VotersOptionLayout";

type VotersOptionLayoutTitleProps = {
	text: string;
	voteCount: number;
	isExpanded: boolean;
	numberFormatter: NumberFormatter;
	onToggle: () => void;
};

const VotersOptionLayoutTitle = (props: VotersOptionLayoutTitleProps): ReactElement => {
	const {
		text,
		voteCount,
		isExpanded,
		onToggle: onToggleFromProps,
		numberFormatter
	} = props;

	const onToggle: (() => void) | undefined = useCallbackWithoutArguments(onToggleFromProps);

	return (
		<div
			{...setTrackingId("title")}
			className={classNames(
				styles.title,
				{
					[styles.title_isExpandable]: isNotNil(onToggle)
				}
			)}
			onClick={onToggle}
		>
			<h4 className={styles.titleText}>
				<FormattedText
					text={localize("_TextWithClarificationFormat")}
					thingsToReplace={[
						{
							what: "{{Text}}",
							filler: text
						},
						{
							what: "{{Clarification}}",
							filler: numberFormatter(voteCount)
						}
					]}
				/>
			</h4>
			<span className={styles.titleIcon}>
				<Icon
					value={isNil(isExpanded) || isExpanded
						? "chevron-up"
						: "chevron-down"
					}
				/>
			</span>
		</div>
	);
};
VotersOptionLayoutTitle.displayName = "VotersOptionLayout.Title";

const VotersOptionLayoutNoVotes = (): ReactElement => {
	return (
		<div className={styles.noVotes}>
			{localize("_CurrentlyThereAreNoVotesOnThisAnswer")}
		</div>
	);
};
VotersOptionLayoutNoVotes.displayName = "VotersOptionLayout.NoVotes";

VotersOptionLayout.Title = VotersOptionLayoutTitle;
VotersOptionLayout.NoVotes = VotersOptionLayoutNoVotes;